import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LightboxState } from '../../../components/interfaces/lightbox.interface';
@Injectable({
  providedIn: 'root'
})
export class CustomLightboxService {
  private readonly lightboxState = new BehaviorSubject<LightboxState>({
  items: [],
  currentIndex: 0,
  isOpen: false,
  isOwner: false,
  experienceType: ''
});

  lightboxState$ = this.lightboxState.asObservable();

  openLightbox(items: any[], index: number, isOwner: boolean, experienceType: string) {
    this.lightboxState.next({ items, currentIndex: index, isOpen: true, isOwner: isOwner, experienceType: experienceType});
  }

  closeLightbox() {
    this.lightboxState.next({ items: [], currentIndex: 0, isOpen: false , isOwner: false, experienceType: ''});
  }

  nextItem() {
    const state = this.lightboxState.value;
    const newIndex = (state.currentIndex + 1) % state.items.length;
    this.lightboxState.next({ ...state, currentIndex: newIndex });
  }

  prevItem() {
    const state = this.lightboxState.value;
    const newIndex = (state.currentIndex - 1 + state.items.length) % state.items.length;
    this.lightboxState.next({ ...state, currentIndex: newIndex });
  }
}
